/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@entrata/portals-common/lib/components';
import { Link } from 'gatsby';
import { WHITE } from 'constants/theme';
import styled from '@emotion/styled';
import { getProductsUrl } from 'constants/common';

const StyledCard = styled(Card)`
  background-color: ${({ theme }) => theme.secondary.light};
  display: flex;
  padding: 16px;
  align-items: center;
  @media (min-width: 320px) {
    min-width: auto !important;
  }
`;

const StyledSpan = styled('span')`
  flex-shrink: 0;
  margin-right: 8px;
`;

const StyledDiv = styled('div')`
  flex: 1;
  margin-bottom: 8px;
  margin-left: 8px;
  color: ${({ theme }) => theme.text.dark};
`;

const StyledH3 = styled('h3')`
  color: ${({ theme }) => theme.secondary.base};
  font-size: 18px;
  margin-top: 8px;
  letter-spacing: 0.5px;
`;

const StyledCardLink = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.light};
  font-size: 16px;
  display: flex;
  display: inline-flex;
  border-radius: 30px;
  padding: 15px 30px;
  color: ${({ theme }) => theme.secondary.base};
  border: 1.5px solid ${({ theme }) => theme.secondary.base};
  svg {
    padding-left: 16px;
  }

  @media only screen and (max-width: 320px) {
    padding: 12px;
  }
`;

const ProductGridItem = ({ children, id, isPetHealthCard, title, quoteVersion, ...props }) => {
  const getQuotePageLink = `/get-quote-${quoteVersion}/`;
  const { petInsuranceUrl } = getProductsUrl();

  return (
    <StyledCard {...props} bare>
      <StyledSpan>
        <props.icon bgFill={WHITE} size={120} />
      </StyledSpan>
      <StyledDiv>
        <StyledH3>{title}</StyledH3>
        <p>{children}</p>
        <StyledCardLink to={isPetHealthCard ? petInsuranceUrl : getQuotePageLink}>Get a quote</StyledCardLink>
      </StyledDiv>
    </StyledCard>
  );
};

ProductGridItem.propTypes = {
  children: PropTypes.string,
  icon: PropTypes.func,
  id: PropTypes.string,
  title: PropTypes.string,
};

export default ProductGridItem;
